<template>
  <div class="card p-fluid mt-4">
    <div class="container">
      <form @submit.prevent="handleSubmit(!v$.$invalid)">        
        <card-prime id="card-prime">
          <template #content>
            <div class="formgrid grid">
              <div class="lg:col-6 col-12 p-0">
                <DropDownLabel
                  id="midia-seleciona"
                  label="Como conheceu nossa escola? *"
                  v-if="midias.length > 0"
                  v-model="v$.Interesse.Midia.$model"
                  :options="midias"
                  :temErro="
                    (v$.Interesse.Midia.$invalid && submitted) ||
                    v$.Interesse.Midia.$pending.$response
                  "
                />
              </div>
              <div class="lg:col-6 col-12 p-0">
                <DropDownLabel
                  id="midia-seleciona"
                  label="Escola anterior"
                  v-model="Interesse.EscolaAnterior"
                  :options="escolasAnteriores"
                  placeholder="Informe o nome da escola"
                  :editavel="true"
                />
              </div>
            </div>
  
            <interesse-component
              v-bind="Interesse.OpcoesInteresse"
              @finalizadoInteresse="ExibirDetalhePreenchimentoInteresse($event)"
            ></interesse-component>
          </template>
        </card-prime>
        <br/>
        <div v-if="exibirDetalhesCadastroInteresse">
          <AlunoComponent :submitted="submitted"></AlunoComponent>
          <br/>
          <ResponsavelComponent :submitted="submitted"></ResponsavelComponent>          
          <br/>          
          <InformacoesAdicionaisComponent></InformacoesAdicionaisComponent>
          <br/>
          <EnvioComponent
            :exibirBotaoEnviar="exibirBotaoEnviar"
            :exibirMensagemErro="exibirMensagemErro"
            :mensagemErro="mensagemErro"
            :mensagemId="mensagemId"
          ></EnvioComponent>
        </div>
        <ScrollTop class="custom-scrolltop" icon="pi pi-arrow-up" />
      </form>
    </div>
  </div>
</template>

<script>
import { required, minLength, email, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { useInteresseStore } from "@/store/interesse";
import { useOpcoesStore } from "@/store/opcoes";
import { useConfiguracoesHttpStore } from "@/store/configuracoesHttp";
import { storeToRefs } from "pinia";
import InteresseComponent from "@/components/interesse/InteresseComponent.vue";
import requisicao from "@/services/Requisicoes/Post/interesseService";
import ResponsavelComponent from "@/components/detalhesInteresse/ResponsavelComponent.vue";
import AlunoComponent from "@/components/detalhesInteresse/AlunoComponent.vue";
import InformacoesAdicionaisComponent from "@/components/detalhesInteresse/InformacoesAdicionaisComponent.vue";
import EnvioComponent from "@/components/detalhesInteresse/EnvioComponent.vue";
import DropDownLabel from "@/components/comuns/DropDownLabel.vue";
import CardPrime from "primevue/card";

export default {
  setup() {
    const storeInteresse = useInteresseStore();
    const storeOpcoes = useOpcoesStore();
    const configuracoesHttpStore = useConfiguracoesHttpStore();
    const { Interesse, Autorizado, enderecoResponsavelIgualAluno } = storeToRefs(storeInteresse);
    const { midias, escolasAnteriores } = storeToRefs(storeOpcoes);

    return {
      v$: useVuelidate(),
      Interesse,
      enderecoResponsavelIgualAluno,
      midias,
      escolasAnteriores,
      Autorizado,
      storeInteresse,
      configuracoesHttpStore,
    };
  },

  name: "InteresseCadastroComponent",

  components: {
    InteresseComponent,
    DropDownLabel,
    ResponsavelComponent,
    AlunoComponent,
    InformacoesAdicionaisComponent,
    EnvioComponent,
    CardPrime,
  },

  data: () => ({
    exibirDetalhesCadastroInteresse: false,
    exibirMensagemErro: false,
    enderecoResponsavelMesmoResponsavelFinanceiro: false,
    exibirBotaoEnviar: true,
    submitted: false,
    mensagemErro: "",
    mensagemId: 0,

    Cliente: {
      nome: "",
      sexo: "",
      dataNascimento: null,
      cep: "",
      logradouro: "",
      numeroLogradouro: "",
      complemento: "",
      bairro: {
        codigo: 0,
        descricao: "",
      },
      cidade: {
        codigo: 0,
        descricao: "",
      },
      uf: "",
      responsavel: {
        nome: "",
        sexo: "",
        tipoVinculo: {
          codigo: 2,
          descricao: "",
          tipoParentesco: 0,
        },
        cpf: "",
        enderecoIgualDoAluno: true,
        cep: "",
        logradouro: "",
        numeroLogradouro: "",
        complemento: "",
        bairro: {
          codigo: 0,
          descricao: "",
        },
        cidade: {
          codigo: 0,
          descricao: "",
        },
        uf: "",
        contatos: [
          {
            tipoContato: 0,
            contato: "",
          },
          {
            tipoContato: 0,
            contato: "",
          },
        ],
      },
      interesse: {
        midia: {
          codigo: 0,
          descricao: "",
        },
        escolaAnterior: {
          codigo: 0,
          descricao: "",
        },
        unidade: {
          codigo: 0,
          descricao: "",
        },
        periodo: {
          codigo: 0,
          descricao: "",
        },
        curso: {
          codigo: 0,
          descricao: "",
        },
        serie: {
          codigo: 0,
          descricao: "",
        },
        turno: {
          codigo: 0,
          descricao: "",
        },
      },
      observacao: "",
      tipoContato: 0,
    },
  }),

  validations() {
    return {
      Interesse: {
        Midia: { required },
        Responsavel: {
          Nome: { required },
          Cpf: { required },
          Sexo: { required },
          Parentesco: { required },
          Email: { required, email },
          Telefone: { required },
          Endereco: this.validaEndereco(this.Interesse.Responsavel.EnderecoObrigatorio || !this.enderecoResponsavelIgualAluno),
        },
        Aluno: {
          Nome: { required },
          DataNascimento: { required, minLength: minLength(10) },
          Sexo: { required },
          Endereco: this.validaEndereco(this.Interesse.Aluno.EnderecoObrigatorio),
        },
      },
    };
  },

  methods: {
    ExibirDetalhePreenchimentoInteresse(formInteresse) {
      if (formInteresse.finalizadoOpcaoInteresse) {
        this.Interesse.OpcoesInteresse.Unidade = formInteresse.Unidade;
        this.Interesse.OpcoesInteresse.Periodo = formInteresse.Periodo;
        this.Interesse.OpcoesInteresse.Curso = formInteresse.Curso;
        this.Interesse.OpcoesInteresse.Serie = formInteresse.Serie;
        this.Interesse.OpcoesInteresse.Turno = formInteresse.Turno;

        return (this.exibirDetalhesCadastroInteresse = true);
      } else {
        this.Interesse.OpcoesInteresse.Unidade = { codigo: 0, descricao: "" };
        this.Interesse.OpcoesInteresse.Periodo = { codigo: 0, descricao: "" };
        this.Interesse.OpcoesInteresse.Curso = { codigo: 0, descricao: "" };
        this.Interesse.OpcoesInteresse.Serie = { codigo: 0, descricao: "" };
        this.Interesse.OpcoesInteresse.Turno = { codigo: 0, descricao: "" };

        return (this.exibirDetalhesCadastroInteresse = false);
      }
    },

    async enviarDados() {                  
      try {
        await requisicao.salvarCliente(
          this.storeInteresse.obterClienteParaEnvio(this.Cliente)
        );
        this.Autorizado = true;
        this.$router.replace(
          `/${this.configuracoesHttpStore.configuracoesHttp.NS}/final`
        );
      } catch {
        this.mensagemErro =
          "Erro no envio dos dados. Tente novamente em alguns instantes.";
        this.exibirMensagemErro = true;
      }
    },

    async handleSubmit(isFormValid) {
      try {
        this.exibirBotaoEnviar = false;
        this.submitted = true;
        this.mensagemId++;
        this.exibirMensagemErro = false;

        if (isFormValid) {
          await this.enviarDados();
        } else {
          this.mensagemErro =
            "Necessário preencher todos os campos obrigatórios antes de realizar o envio dos dados.";
          this.exibirMensagemErro = true;
        }
      } catch {
        this.mensagemErro =
          "Erro no envio dos dados. Tente novamente em alguns instantes.";
        this.exibirMensagemErro = true;
      } finally {
        this.exibirBotaoEnviar = true;
      }
    },
    validaEndereco(enderecoObrigatorio) {
      return {
        Cep: {
          requiredIf: requiredIf(
            () => enderecoObrigatorio
          ),
        },
        Logradouro: {
          requiredIf: requiredIf(
            () => enderecoObrigatorio
          ),
        },
        Numero: {
          requiredIf: requiredIf(
            () => enderecoObrigatorio
          ),
        },
        Bairro: {
          requiredIf: requiredIf(
            () => enderecoObrigatorio
          ),
        },
        Cidade: {
          requiredIf: requiredIf(
            () => enderecoObrigatorio
          ),
        },
        Estado: {
          requiredIf: requiredIf(
            () => enderecoObrigatorio
          ),
        },
      };
    },
  },

  watch: {
    "Interesse.ContatoEmail": function (valorNovo) {
      this.Interesse.ContatoTelefone = !valorNovo;
    },

    "Interesse.ContatoTelefone": function (valorNovo) {
      this.Interesse.ContatoEmail = !valorNovo;
    },

    "Interesse.Responsavel.Endereco": {
      handler(valorNovo) {
        this.Interesse.Responsavel.EnderecoObrigatorio =
          this.storeInteresse.enderecoObrigatorio(valorNovo);
      },
      deep: true,
    },
    
    "Interesse.Aluno.Endereco": {
      handler(valorNovo) {
        this.Interesse.Aluno.EnderecoObrigatorio =
          this.storeInteresse.enderecoObrigatorio(valorNovo);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.custom-scrolltop) {
  width: 2rem;
  height: 2rem;
  border-radius: 4px;
  background-color: var(--primary-color) !important;

  &:hover {
    background-color: var(--primary-color) !important;
  }

  .p-scrolltop-icon {
    font-size: 1rem;
    color: var(--primary-color-text) !important;
  }
}
</style>